"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const mark_1 = require("./mark");
class Underline extends mark_1.Mark {
    constructor() {
        super('underline');
    }
}
exports.Underline = Underline;
//# sourceMappingURL=underline.js.map